//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LinsesDescription from '~/components/linses/LinsesDescription'
import LinsesBenefits from '~/components/linses/LinsesBenefits'
import LinsesParametrs from '~/components/linses/LinsesParametrs'
import LinsesOffers from '~/components/linses/LinsesOffers'
import LinsesTitle from '~/components/linses/LinsesTitle'
import SPage from '~/components/page/SPage.vue'
import CategoryNavigation from '~/components/linses/CategoryNavigation.vue'
import LensesGlassesSelection from "~/components/linses/LensesGlassesSelection.vue";

export default {
  name: 'subpage',
  components: {
    CategoryNavigation,
    LinsesTitle,
    LinsesOffers,
    LinsesParametrs,
    LinsesBenefits,
    LinsesDescription,
    SPage,
    LensesGlassesSelection
  },
  methods: {
    formatPrice(price) {
      if (!price) {
        return '-'
      }

      const formatedPrice = price.replace(/[^0-9.]/g, '')
      return `${this.$numberFormat(formatedPrice)} ₽`
    },
    // async updateLense({$api, newParams}) {
    //   const slug = newParams?.category
    //
    //   const lense = await $api.agent.transport
    //     .get(`competitors/lens-by-slug/${slug}`)
    //     .then(res => {
    //       return res.data
    //     })
    //     .catch(err => {
    //       console.log(err.response, 'error')
    //       error({statusCode: err.response.status})
    //     })
    //   this.linza = lense
    // }
  },
  head() {
    const meta = [
      {
        hid: 'metadescription',
        name: 'description',
        content: this?.linza?.seo_description || '',
      },
    ]

    return {
      title: this?.linza?.seo_title || this?.linza?.additional_title || '',
      meta: meta,
    }
  },
  async asyncData({$api, error, params}) {
    const slug = params?.category
    const linza = await $api.agent.transport
      .get(`competitors/lens-by-slug/${slug}`)
      .then(res => {
        return res.data
      })
      .catch(err => {
        console.log(err.response, 'error')
        error({statusCode: err.response.status})
      })

    const lensesList = await $api.agent.transport
      .get('competitors/category')
      .then(res => {
        return res.data.filter(category => category.name !== 'Линзы для детей')
      })
      .catch(err => {
        console.log(err.response, 'error')
        error({statusCode: err.response.status})
      })

    return {
      linza,
      lensesList
    }
  },


  computed: {
    linkSettings() {
      return {
        link: this?.linza?.link,
        linkText: this?.linza?.link_text,
      }
    },
    recommendations() {
      return this?.linza?.recommendations || ''
    },
    productionTime() {
      return this?.linza?.production_time || ''
    },
    title() {
      return `${this?.linza?.additional_title || ''} <br/> <span> от ${this.formatPrice(this?.linza?.min_price)}</span>` || ''
    },
    subtitle() {
      return this?.linza?.inner_full_title || ''
    },
    linsesOffer() {
      return this.linza?.reflections || ''
    },
    linsesTypeText() {
      return this.linza?.lens_type_texts || [];
    },
    breadcrumbs() {
      return [{
        title: 'Главная',
        path: '/'
      },
        {
          title: 'Сравнение линз',
          path: '/lenses'
        },
        {
          title: this?.linza?.title,
          path: this?.linza?.slug
        },
      ]
    },
    bannerId() {
      return this.linza?.banner_image_id || 0
    },
    bannerLink() {
      return this.linza?.banner_image_link || ''
    },

    cmsPageId: function () {
      return Number.parseFloat(this.$store.state.appState?.vars?.['Шаблон для сравнения линз'] || '0')
    },
    cmsPageIdFeedbacks: function () {
      return Number.parseFloat(this.$store.state.appState?.vars?.['Шаблон для страницы - Отзывы к разделу с линзами для очков'] || '0')
    }
  }
}
